import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useAuthStore } from "@/store/auth.store";
import { useNavigate } from "react-router-dom";

interface WarningModalProps {
  isViewWarningModal: boolean;
  setIsViewWarningModal: (value: boolean) => void;
  freePoints?: string;
}

const Header: React.FC<{ title: string }> = ({ title }) => (
  <div className="bg-orange h-[71px] rounded-tl-lg rounded-tr-lg flex items-center justify-center relative">
    <img className="w-[89px] h-[64px] top-[7px] left-[13px] absolute" src="/assets/YOSOMI.png" alt="YOSOMI" />
    <div className="text-white text-center text-[24px] font-bold leading-[35px]">{title}</div>
    <img
      src="/assets/_編集モード.png"
      className="h-[62.397px] w-[76.947px] right-[13.05px] top-[3.84px] absolute"
      alt="_編集モード"
    />
  </div>
);

const CloseButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <div className="mb-[21px] mt-[14px] mx-[30px] flex justify-center items-center">
    <Button className="text-base underline" variant="link" onClick={onClick}>
      閉じる
    </Button>
  </div>
);

export const WarningModal: React.FC<WarningModalProps> = ({
  isViewWarningModal,
  setIsViewWarningModal,
  freePoints,
}) => {
  const isUnauthenticated = useAuthStore((state) => state.authState === "unauthenticated");
  const navigate = useNavigate();

  const handleClose = () => setIsViewWarningModal(false);

  const handleLogin = () => {
    handleClose();
    navigate("/login");
  };

  const handleRedeem = () => {
    handleClose();
    navigate("/redeem-points");
  };

  let content: React.ReactNode = null;

  if (isUnauthenticated) {
    content = (
      <div className="flex flex-col">
        <Header title="TIPS" />
        <div className="text-center font-bold text-[20px] leading-[24px] text-black mt-[27px]">
          まだログインされていません！
        </div>
        <div className="mt-[15px] text-center font-medium text-[16px] leading-[24px] text-black mx-7">
          ログインすると、ランキングにあなたの順位が表示され、サンバをもっと楽しめるようになります！
        </div>
        <Button
          className="text-lg py-[25px] text-white rounded-lg font-bold mt-[26px] mx-[23px] outline-none bg-primary hover:bg-primary"
          variant="default"
          onClick={handleLogin}
        >
          ログインする
        </Button>
        <CloseButton onClick={handleClose} />
      </div>
    );
  } else if (!freePoints || freePoints === "0") {
    content = (
      <div className="flex flex-col">
        <Header title="TIPS" />
        <div className="text-center font-bold text-[20px] leading-[24px] text-black mt-[27px]">現在のポイント：0pt</div>
        <div className="mt-[15px] text-center font-medium text-[16px] leading-[24px] text-black mx-7">
          順位を上げるにはポイントが必要です。今すぐ無料ポイントをゲットして、ランクアップを目指そう！
        </div>
        <Button
          className="text-lg py-[25px] text-white rounded-lg font-bold mt-[26px] mx-[23px] bg-green hover:bg-green outline-none"
          variant="default"
          onClick={handleRedeem}
        >
          ポイントを獲得する
        </Button>
        <CloseButton onClick={handleClose} />
      </div>
    );
  }
  return (
    <Dialog open={isViewWarningModal} onOpenChange={setIsViewWarningModal}>
      <DialogContent className="[&>button]:hidden w-[380px] p-0 ring-0 ring-transparent">{content}</DialogContent>
    </Dialog>
  );
};
